import { render, staticRenderFns } from "./SSFooter.vue?vue&type=template&id=2f31f2ae&scoped=true&"
import script from "./SSFooter.vue?vue&type=script&lang=js&"
export * from "./SSFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31f2ae",
  null
  
)

export default component.exports